!function(window) {
// babel-polyfills
// require("babel-polyfill");


/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */
 jQuery.cookie = function (name, value, options) {
	if (typeof value != "undefined") {
		options = options || {};
		if (value === null) {
			value = "";
			options.expires = -1
		}
		var expires = "";
		if (options.expires && (typeof options.expires == "number" || options.expires.toUTCString)) {
			var date;
			if (typeof options.expires == "number") {
				date = new Date();
				date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000))
			} else {
				date = options.expires
			}
			expires = "; expires=" + date.toUTCString()
		}
		var path = options.path ? "; path=" + (options.path) : "";
		var domain = options.domain ? "; domain=" + (options.domain) : "";
		var secure = options.secure ? "; secure" : "";
		document.cookie = [name, "=", encodeURIComponent(value), expires, path, domain, secure].join("")
	} else {
		var cookieValue = null;
		if (document.cookie && document.cookie != "") {
			var cookies = document.cookie.split(";");
			for (var i = 0; i < cookies.length; i++) {
				var cookie = jQuery.trim(cookies[i]);
				if (cookie.substring(0, name.length + 1) == (name + "=")) {
					cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
					break
				}
			}
		}
		return cookieValue
	}
};

require("../jquery-extended-arctur")(jQuery);
require("../form.validators")(jQuery);

// URL plugin

jQuery.url = function () {
	var segments = {};
	var parsed = {};
	var options = {
		url: window.location,
		strictMode: false,
		key: ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"],
		q: {
			name: "queryKey",
			parser: /(?:^|&)([^&=]*)=?([^&]*)/g
		},
		parser: {
			strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*):?([^:@]*))?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
			loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*):?([^:@]*))?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
		}
	};
	var parseUri = function () {
		var str = decodeURI(options.url);
		var m = options.parser[options.strictMode ? "strict" : "loose"].exec(str);
		var uri = {};
		var i = 14;
		while (i--) {
			uri[options.key[i]] = m[i] || ""
		}
		uri[options.q.name] = {};
		uri[options.key[12]].replace(options.q.parser, function ($0, $1, $2) {
			if ($1) {
				uri[options.q.name][$1] = $2
			}
		});
		return uri
	};
	var key = function (key) {
		if (!parsed.length) {
			setUp()
		}
		if (key == "base") {
			if (parsed.port !== null && parsed.port !== "") {
				return parsed.protocol + "://" + parsed.host + ":" + parsed.port + "/"
			} else {
				return parsed.protocol + "://" + parsed.host + "/"
			}
		}
		return (parsed[key] === "") ? null : parsed[key]
	};
	var param = function (item) {
		if (!parsed.length) {
			setUp()
		}
		return (parsed.queryKey[item] === null) ? null : parsed.queryKey[item]
	};
	var setUp = function () {
		parsed = parseUri();
		getSegments()
	};
	var getSegments = function () {
		var p = parsed.path;
		segments = [];
		segments = parsed.path.length == 1 ? {} : (p.charAt(p.length - 1) == "/" ? p.substring(1, p.length - 1) : p.substring(1)).split("/")
	};
	return {
		setMode: function (mode) {
			strictMode = mode == "strict" ? true : false;
			return this
		},
		setUrl: function (newUri) {
			options.url = newUri === undefined ? window.location : newUri;
			setUp();
			return this
		},
		segment: function (pos) {
			if (!parsed.length) {
				setUp()
			}
			if (pos === undefined) {
				return segments.length
			}
			return (segments[pos] === "" || segments[pos] === undefined) ? null : segments[pos]
		},
		attr: key,
		param: param
	}
}();


// nastavi invisible recaptcho za vse forme in jo pokliče na submit forme

var captchaCallback = function(){
	var widgetAttr = 'data-widgetid';
	var recaptchaClass = '.g-recaptcha';
	var recaptchaRespons = '.g-recaptcha-response';
	$(recaptchaClass).each(function(index, el) {
		var form = $(el).closest("form");
		var widgetId = grecaptcha.render(el, {
			'sitekey' : jQuery(el).attr('data-sitekey'), 
			'callback' : token => {
				form.find(recaptchaRespons).val(token);
				form.submit();
			}
		});
		$(el).attr(widgetAttr, widgetId);
	});

	$('.arctur-form [type=submit]').on('click', function(ev) {
		ev.preventDefault();
		var widgetId = $(this).closest('form').find(recaptchaClass).attr(widgetAttr);
		grecaptcha.execute(widgetId);	
	});
}


//global variables for responsivness

var urlDirFull = jQuery.url.attr("directory");
var pageLng = null;


function initilizeLanguageSettings() {
	/* --- language settings --- */

	var htmlLang = $('html').attr('lang');
	if (htmlLang == 'sl') {
		pageLng = 'slo';
	} else if (htmlLang == 'it') {
		pageLng = 'ita';
	} else if (htmlLang == 'de') {
		pageLng = 'deu';
	} else if (htmlLang == 'hr') {
		pageLng = 'hrv';
	} else {
		pageLng = 'eng';
	}

	if (pageLng == 'slo' || pageLng == 'hrv') {
		Date.format = 'dd.mm.yyyy';
		Date.firstDayOfWeek = 1;
		Date.dayNames = ['Nedelja', 'Ponedeljek', 'Torek', 'Sreda', 'Četrtek', 'Petek', 'Sobota'];
		Date.abbrDayNames = ['Ned', 'Pon', 'Tor', 'Sre', 'Čet', 'Pet', 'Sob'];
		Date.monthNames = ['januar', 'februar', 'marec', 'april', 'maj', 'junij', 'julij', 'avgust', 'september', 'oktober', 'november', 'december'];
		Date.abbrMonthNames = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'avg', 'sep', 'okt', 'nov', 'dec'];

		$.dpText = {
			TEXT_PREV_YEAR: 'Prejšnje leto',
			TEXT_PREV_MONTH: 'Prejšnji mesec',
			TEXT_NEXT_YEAR: 'Naslednje leto',
			TEXT_NEXT_MONTH: 'Naslednji mesec',
			TEXT_CLOSE: 'Zapri',
			TEXT_CHOOSE_DATE: 'Izberi datum'
		}
	} else {
		Date.format = 'dd.mm.yyyy';
		Date.firstDayOfWeek = 1;
		Date.dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
		Date.abbrDayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
		Date.monthNames = ['January', 'February', 'March', 'April', 'May', 'Jun', 'Julay', 'August', 'September', 'October', 'November', 'December'];
		Date.abbrMonthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

		$.dpText = {
			TEXT_PREV_YEAR: 'Previews year',
			TEXT_PREV_MONTH: 'Previews month',
			TEXT_NEXT_YEAR: 'Next year',
			TEXT_NEXT_MONTH: 'Next month',
			TEXT_CLOSE: 'Close',
			TEXT_CHOOSE_DATE: 'Select date'
		}
	}
}

function viewport() {
	var e = window,
		a = 'inner';
	if (!('innerWidth' in window)) {
		a = 'client';
		e = document.documentElement || document.body;
	}
	return {
		width: e[a + 'Width'],
		height: e[a + 'Height']
	};
}


/**Functions that dont require document to be ready */
initilizeLanguageSettings();


jQuery(document).ready(function () {

	var options = {
		viewport: {
			size: viewport,
			definition: {
				xs: 480,
				sm: 768,
				md: 992,
				lg: 1230
			}
		}
	}



	require("./various-utils")(jQuery);
	
	// main menu bootstrap
	require("./main-menu-bootstrap")(options);

	// main menu legacy - uncomment if needed
	//require("./main-menu-legacy");



	function submitHelper() {
		$('.submit-helper').on('click', function(ev) {
			ev.preventDefault();
			ev.stopPropagation();

			$(this).closest('form').submit();
		});
	}
	submitHelper();

	$(window).scroll(function() {
		if($(window).scrollTop() == $(document).height() - $(window).height()){
			$('#cookie-button').show();
		}else{
			$('#cookie-button').hide();
		}
	});





	/* --- "on load" --- */

	$('input:text').textBoxHint(); // titles to input text
	$("article a, ul.grouped-link-list a").markExternalLinks(); // adds class to external links

	$("a[rel^='magnific']").magnificPopup({
		type: 'image',
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			tCounter: '%curr%\/%total%'
		},
		closeBtnInside: false,
		closeOnBgClick: true
	});


	/* Wait for the whole page to load, including images. */
	$(window).load(function () {
	});

});


/* --- Non-jQuery functions below --- */

//check if just one checkbox is checked
function isChecked(formId, message) {
	var form = document.getElementById(formId);

	for (i = 0; i < form.elements.length; i++) {
		if (form.elements[i].checked == true) {
			return true;
		}
	}
	alert(message);
	return false;
}

//mail decode
var mDec = function mDec(ensl, enlsShow, addToHref, insertHtml) {
	if (enlsShow == undefined || enlsShow == "") {
		enlsShow = ensl;
	}

	if (addToHref == undefined) {
		addToHref = "";
	}

	let a = "pdlowr=" + ensl;
	let nslv = "";
	for (let i = 0; i < a.length; i++) {
		let n = a.charCodeAt(i) - 3;
		nslv += String.fromCharCode(n);
	}

	let s = "";
	for (let i = 0; i < enlsShow.length; i++) {
		let n = enlsShow.charCodeAt(i);
		if (n >= 35 && n <= 126) {
			s += String.fromCharCode(n - 3);
		} else {
			s += enlsShow.charAt(i);
		}
	}

	if (insertHtml == '') {
		insertHtml = s;
	}

	document.write("<a class=\"email\" href=\"" + nslv + addToHref + "\">" + insertHtml + "</a>");
};


/*
 * function get elements by class name ... simiar to getElementsByTagName
 * leave container arg out, and will default to document.
 */
function getElementsByClassName(className, container) {
	if (!container) {
		container = document;
	}
	if (container.all) {
		var all = container.all;
	} else {
		var all = container.getElementsByTagName('*');
	}
	var arr = [];
	for (var k = 0; k < all.length; k++) {
		if (all[k].className == className) {
			arr[arr.length] = all[k];
		}
	}
	return arr;
}

/*
 * Closes a tree of uls/lis (a menu for example) if scripts are enabled. Else leaves
 * the list open, so it is accessible to other users.
 * Note: this could be done in jQuery, but the list needs to close
 * as soon as it is loaded, so jQuery is not an option here.
 */
function closeList(listId, sublevelsClassName, closeAtLevel) {
	var list = document.getElementById(listId);

	for (var i = closeAtLevel; i < 5; ++i) {
		var aUls = getElementsByClassName(sublevelsClassName + i, list);
		for (var j = 0; j < aUls.length; ++j) {
			if (aUls[j].tagName == 'UL') { // only close ULs
				aUls[j].style.display = "none";
			}
		}
	}
}

/*
 * Closes any element by ID
 */
function hideElementById(elId) {
	var el = document.getElementById(elId);
	el.style.display = "none";
}


// if (document.getElementsByTagName) {
// 	var inputElements = document.getElementsByTagName("input");
// 	for (var i = 0; inputElements[i]; i++) {
// 		if (inputElements[i].className && (inputElements[i].className.indexOf("disableAutoComplete") != -1)) {
// 			inputElements[i].setAttribute("autocomplete", "off");
// 		}
// 	}
// }
window.captchaCallback = captchaCallback;
window.urlDirFull = urlDirFull;
window.pageLng = pageLng;
window.initilizeLanguageSettings = initilizeLanguageSettings;
window.viewport = viewport;
window.isChecked = isChecked;
window.mDec = mDec;
window.getElementsByClassName = getElementsByClassName;
window.closeList = closeList;
window.hideElementById = hideElementById;
}.call(window, window);